"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react-hooks/exhaustive-deps */
require("../../scss/cookieConsentItemChoice.scss");
const react_1 = __importStar(require("react"));
const react_toggle_1 = __importDefault(require("react-toggle"));
require("react-toggle/style.css"); // for ES6 modules
const useCookiesConsent_1 = require("../../hooks/useCookiesConsent");
const useService_1 = require("../../hooks/useService");
function CookieConsentItemChoice(props) {
    var _a;
    const [toggle, setToggle] = (0, react_1.useState)();
    const { cookieConsentPreferences, setCookieConsentPreferences, intlLang, config } = (0, useCookiesConsent_1.useCookiesConsent)();
    const cookieService = (0, useService_1.useService)('CookieService');
    const { cookieConsentPreferenceItem, } = props;
    (0, react_1.useEffect)(() => {
        setToggle(cookieConsentPreferences[cookieConsentPreferenceItem.cookieConsentPreferencesName]);
    }, [cookieConsentPreferenceItem.cookieConsentPreferencesName, cookieConsentPreferences]);
    const changeToggleState = () => {
        cookieConsentPreferences[cookieConsentPreferenceItem.cookieConsentPreferencesName] = !toggle;
        cookieService.setCookieConsentPreferences(cookieConsentPreferences);
        setCookieConsentPreferences(cookieConsentPreferences);
        setToggle(!toggle);
    };
    return (react_1.default.createElement("div", { className: "cookie-consent-item" },
        react_1.default.createElement("div", { className: "cookie-consent-item-header" },
            react_1.default.createElement("span", { className: "cookie-consent-item-title" }, cookieConsentPreferenceItem.title[intlLang]),
            cookieConsentPreferenceItem.isAlwaysActive ? (react_1.default.createElement("span", { className: "cookie-consent-item-title-on" }, (_a = config.textAlwaysActive) === null || _a === void 0 ? void 0 : _a[intlLang])) : (react_1.default.createElement("div", { className: "cookie-consent-item-toggle" },
                react_1.default.createElement(react_toggle_1.default, { checked: toggle, icons: false, onChange: changeToggleState })))),
        react_1.default.createElement("div", { className: "cookie-consent-item-choice" }),
        react_1.default.createElement("div", { className: "cookie-consent-item-text" },
            react_1.default.createElement("p", null, cookieConsentPreferenceItem.description[intlLang]))));
}
exports.default = CookieConsentItemChoice;
//# sourceMappingURL=CookieConsentItemChoice.js.map